// extracted by mini-css-extract-plugin
module.exports = {"alert":"Errors_alert__2grA5","button":"Errors_button__5edI2"};